import { render, staticRenderFns } from "./RiskCreateEditPage.vue?vue&type=template&id=99aebf6a&"
import script from "./RiskCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./RiskCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports